var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLMultiSelect",
    _vm._g(
      _vm._b(
        {
          attrs: {
            required: true,
            showTip: false,
            fusionInputCheckPattern: _vm.multiSelectNotEmptyPattern,
            options: _vm.options,
          },
        },
        "HKLMultiSelect",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }